import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "🎉 Fast geschafft!", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Lade die PDF herunter und drucke Sie mit den entsprechend Einstellungen aus. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "MRV:"),
    /*#__PURE__*/_createTextVNode(" Du findest eine Druck-Anleitung im "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "http://wiki.mrv-net.local/de/B%C3%BCro/Gru%C3%9Fkarten",
      target: "_blank"
    }, "Wiki"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createVNode(_component_Button, {
        class: "p-mr-2 p-button-secondary",
        type: "submit",
        label: "Zurück",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('3')))
      }),
      _createVNode(_component_Button, {
        class: "p-mt-4 p-button-success",
        type: "submit",
        label: "PDF herunterladen",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.generatePDF()))
      })
    ]),
    _createVNode(_component_Accordion, { class: "p-mt-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, { header: "Anleitung: Druckereinstellungen damit die Karten gedruckt werden können" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}